import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-common-footer-fixed-no-login" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "c-common-footer-fixed-no-login__inner" }, [
      _createElementVNode("div", { class: "p-sso-logout" }, [
        _createElementVNode("h3", null, "SSO Logout"),
        _createElementVNode("p", null, "正常にログアウトしました。"),
        _createElementVNode("p", null, "ブラウザの「×」(閉じる)ボタンで閉じてください。")
      ])
    ], -1)),
    _createVNode(_component_TheFooter)
  ]))
}